/**
 * Delivery options config
 * ------------------------------------------------------------------------------
 * Configuration file used in delivery-selector.js.
 * - Delivery options defined here will be used in the selector.
 */
window.Frame = window.Frame || {};
window.Frame.DeliverySelector = {
  groups: [
    {
      name: 'AB',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB30',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB31',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB32',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB33',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB34',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB35',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB36',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB37',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB38',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB40',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB41',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB42',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB43',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB44',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB45',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB46',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB47',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB48',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB49',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB50',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB51',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB52',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB53',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB54',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB55',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB56',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'AB63',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'BH19',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'BH20',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'CA',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'CM0',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'DD',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'DD10',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'DD8',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'DD9',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'DG',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'DG1',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'DG10',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
      [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ]
      ],
      services: [
      {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
      },
      {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
      },
      {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [          '2022-12-01', '2022-12-02',
          '2022-12-03', '2022-12-04',
          '2022-12-05', '2022-12-06',
          '2022-12-07', '2022-12-08',
          '2022-12-09', '2022-12-10',
          '2022-12-11', '2022-12-12',
          '2022-12-13', '2022-12-14',
          '2022-12-15', '2022-12-16',
          '2022-12-17', '2022-12-18',
          '2022-12-19', '2022-12-20',
          '2022-12-21', '2022-12-22'
          ]
      }
      ]
  },
  {
      name: 'DG11',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
      [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ]
      ],
      services: [
      {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
      },
      {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
      },
      {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [          '2022-12-01', '2022-12-02',
          '2022-12-03', '2022-12-04',
          '2022-12-05', '2022-12-06',
          '2022-12-07', '2022-12-08',
          '2022-12-09', '2022-12-10',
          '2022-12-11', '2022-12-12',
          '2022-12-13', '2022-12-14',
          '2022-12-15', '2022-12-16',
          '2022-12-17', '2022-12-18',
          '2022-12-19', '2022-12-20',
          '2022-12-21', '2022-12-22'
          ]
      }
      ]
  },
  {
      name: 'DG12',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
      [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ]
      ],
      services: [
      {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
      },
      {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
      },
      {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [          '2022-12-01', '2022-12-02',
          '2022-12-03', '2022-12-04',
          '2022-12-05', '2022-12-06',
          '2022-12-07', '2022-12-08',
          '2022-12-09', '2022-12-10',
          '2022-12-11', '2022-12-12',
          '2022-12-13', '2022-12-14',
          '2022-12-15', '2022-12-16',
          '2022-12-17', '2022-12-18',
          '2022-12-19', '2022-12-20',
          '2022-12-21', '2022-12-22'
          ]
      }
      ]
  },
  {
      name: 'DG13',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
      [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ]
      ],
      services: [
      {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
      },
      {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
      },
      {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [          '2022-12-01', '2022-12-02',
          '2022-12-03', '2022-12-04',
          '2022-12-05', '2022-12-06',
          '2022-12-07', '2022-12-08',
          '2022-12-09', '2022-12-10',
          '2022-12-11', '2022-12-12',
          '2022-12-13', '2022-12-14',
          '2022-12-15', '2022-12-16',
          '2022-12-17', '2022-12-18',
          '2022-12-19', '2022-12-20',
          '2022-12-21', '2022-12-22'
          ]
      }
      ]
  },
  {
      name: 'DG14',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
      [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ]
      ],
      services: [
      {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
      },
      {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
      },
      {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [          '2022-12-01', '2022-12-02',
          '2022-12-03', '2022-12-04',
          '2022-12-05', '2022-12-06',
          '2022-12-07', '2022-12-08',
          '2022-12-09', '2022-12-10',
          '2022-12-11', '2022-12-12',
          '2022-12-13', '2022-12-14',
          '2022-12-15', '2022-12-16',
          '2022-12-17', '2022-12-18',
          '2022-12-19', '2022-12-20',
          '2022-12-21', '2022-12-22'
          ]
      }
      ]
  },
  {
      name: 'DG15',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
      [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ]
      ],
      services: [
      {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
      },
      {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
      },
      {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [          '2022-12-01', '2022-12-02',
          '2022-12-03', '2022-12-04',
          '2022-12-05', '2022-12-06',
          '2022-12-07', '2022-12-08',
          '2022-12-09', '2022-12-10',
          '2022-12-11', '2022-12-12',
          '2022-12-13', '2022-12-14',
          '2022-12-15', '2022-12-16',
          '2022-12-17', '2022-12-18',
          '2022-12-19', '2022-12-20',
          '2022-12-21', '2022-12-22'
          ]
      }
      ]
  },
  {
      name: 'DG16',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
      [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ]
      ],
      services: [
      {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
      },
      {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
      },
      {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [          '2022-12-01', '2022-12-02',
          '2022-12-03', '2022-12-04',
          '2022-12-05', '2022-12-06',
          '2022-12-07', '2022-12-08',
          '2022-12-09', '2022-12-10',
          '2022-12-11', '2022-12-12',
          '2022-12-13', '2022-12-14',
          '2022-12-15', '2022-12-16',
          '2022-12-17', '2022-12-18',
          '2022-12-19', '2022-12-20',
          '2022-12-21', '2022-12-22'
          ]
      }
      ]
    },
    {
      name: 'DG2',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'DG3',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'DG4',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'DG5',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },    {
      name: 'DG6',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'DG7',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'DG8',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'DG9',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'DL11',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'DL12',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'DL13',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'DL8',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'DT3',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'DT4',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'DT5',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'EC',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'FK17',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'FK18',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'FK19',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'FK20',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'FK21',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'G84',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'HR1',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'HR2',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'HR3',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'HR4',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'HR5',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'HR6',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'HR7',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'HR8',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'HR9',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'HU12',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'HU19',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'IV',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV1',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV10',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV11',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV12',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV13',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV14',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV15',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV16',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV17',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV18',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV19',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV2',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV20',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV21',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV22',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV23',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV24',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV25',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV26',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV27',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV28',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV29',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV3',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV30',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV31',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV32',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV33',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV34',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV35',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV36',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV4',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV40',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV41',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: {
            mon: 13,
            tue: 13,
            wed: 13,
            thu: 13,
            fri: 11,
            sat: 11,
            sun: 12
          },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV42',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: {
            mon: 13,
            tue: 13,
            wed: 13,
            thu: 13,
            fri: 11,
            sat: 11,
            sun: 12
          },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV43',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: {
            mon: 13,
            tue: 13,
            wed: 13,
            thu: 13,
            fri: 11,
            sat: 11,
            sun: 12
          },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV44',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: {
            mon: 13,
            tue: 13,
            wed: 13,
            thu: 13,
            fri: 11,
            sat: 11,
            sun: 12
          },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV45',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: {
            mon: 13,
            tue: 13,
            wed: 13,
            thu: 13,
            fri: 11,
            sat: 11,
            sun: 12
          },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV46',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: {
            mon: 13,
            tue: 13,
            wed: 13,
            thu: 13,
            fri: 11,
            sat: 11,
            sun: 12
          },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV47',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: {
            mon: 13,
            tue: 13,
            wed: 13,
            thu: 13,
            fri: 11,
            sat: 11,
            sun: 12
          },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV48',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: {
            mon: 13,
            tue: 13,
            wed: 13,
            thu: 13,
            fri: 11,
            sat: 11,
            sun: 12
          },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV49',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: {
            mon: 13,
            tue: 13,
            wed: 13,
            thu: 13,
            fri: 11,
            sat: 11,
            sun: 12
          },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV5',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV50',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV51',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: {
            mon: 13,
            tue: 13,
            wed: 13,
            thu: 13,
            fri: 11,
            sat: 11,
            sun: 12
          },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV52',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: {
            mon: 13,
            tue: 13,
            wed: 13,
            thu: 13,
            fri: 11,
            sat: 11,
            sun: 12
          },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV53',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: {
            mon: 13,
            tue: 13,
            wed: 13,
            thu: 13,
            fri: 11,
            sat: 11,
            sun: 12
          },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV54',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: {
            mon: 13,
            tue: 13,
            wed: 13,
            thu: 13,
            fri: 11,
            sat: 11,
            sun: 12
          },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV55',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: {
            mon: 13,
            tue: 13,
            wed: 13,
            thu: 13,
            fri: 11,
            sat: 11,
            sun: 12
          },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV56',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: {
            mon: 13,
            tue: 13,
            wed: 13,
            thu: 13,
            fri: 11,
            sat: 11,
            sun: 12
          },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV6',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV63',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV7',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV8',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'IV9',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'KA1',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA10',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA11',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA12',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA13',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA14',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA15',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA16',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA17',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA18',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA19',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA2',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA20',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA21',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA22',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA23',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA24',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA25',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA26',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA27',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: {
            mon: 13,
            tue: 13,
            wed: 13,
            thu: 13,
            fri: 11,
            sat: 11,
            sun: 12
          },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA28',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: {
            mon: 13,
            tue: 13,
            wed: 13,
            thu: 13,
            fri: 11,
            sat: 11,
            sun: 12
          },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA3',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA4',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA5',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA6',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA7',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA8',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KA9',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KW',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KW1',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KW10',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KW11',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KW12',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KW13',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KW14',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KW15',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: {
            mon: 13,
            tue: 13,
            wed: 13,
            thu: 13,
            fri: 11,
            sat: 11,
            sun: 12
          },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KW16',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: {
            mon: 13,
            tue: 13,
            wed: 13,
            thu: 13,
            fri: 11,
            sat: 11,
            sun: 12
          },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KW17',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: {
            mon: 13,
            tue: 13,
            wed: 13,
            thu: 13,
            fri: 11,
            sat: 11,
            sun: 12
          },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KW2',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KW3',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KW4',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KW5',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KW6',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KW7',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KW8',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KW9',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'KY',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LA18',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LA19',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LA20',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LD',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LD1',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LD2',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LD3',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LD4',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LD5',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LD6',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LD7',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LD8',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LL11',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LL12',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LL13',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LL14',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LL15',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LL16',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LL17',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LL18',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LL19',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LL20',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LL21',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LL22',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LL23',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LL24',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LL25',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LL26',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LL27',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LL28',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LL29',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LL30',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LL31',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LL32',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LL33',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LL34',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'LL35',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
      ]
    },
    {
      name: 'LL36',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL37',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL38',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL39',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL40',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL41',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL42',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL43',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL44',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL45',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL46',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL47',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL48',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL49',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL51',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL52',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL53',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL54',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL55',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL56',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL57',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL58',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL59',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL60',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL61',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL62',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL63',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL64',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL65',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL66',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL67',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL68',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL69',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL70',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL71',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL72',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL73',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL74',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL75',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL76',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL77',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'LL78',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        }
      ]
    },
    {
      name: 'ME11',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'ME12',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'ME3',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'NE19',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'NE46',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'NE47',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'NE48',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'NE49',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'NE65',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'NE66',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'NE67',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'NE68',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'NE69',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'NE70',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'NE71',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },

    {
      name: 'PH',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 6
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH1',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
        name: 'PH10',
        leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
        excludedDays: [],
        excludedDates: [
          [
            '2022-12-23',
            '2022-12-24',
            '2022-12-25',
            '2022-12-26',
            '2022-12-27',
            '2022-12-31',
            '2023-01-01'
          ]
        ],
        services: [
          {
            title: 'Free Delivery',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
            productHandle: 'standard-weekday'
          },
          {
            title: 'Bike Delivery',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            productHandle: 'panther-weekday'
          },
          {
            title: 'Christmas premium - 2 hour time slot provided',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            productHandle: 'premium-christmas-delivery',
            seasonalDelivery: true,
            includedDays: [
              '2022-12-19', '2022-12-20',
              '2022-12-21', '2022-12-22'
            ]
          },
          {
            title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            seasonalDelivery: true,
            includedDays: [],
            productHandle: 'panther-weekday'
          }
        ]
      },
      {
        name: 'PH11',
        leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
        excludedDays: [],
        excludedDates: [
          [
            '2022-12-23',
            '2022-12-24',
            '2022-12-25',
            '2022-12-26',
            '2022-12-27',
            '2022-12-31',
            '2023-01-01'
          ]
        ],
        services: [
          {
            title: 'Free Delivery',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
            productHandle: 'standard-weekday'
          },
          {
            title: 'Bike Delivery',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            productHandle: 'panther-weekday'
          },
          {
            title: 'Christmas premium - 2 hour time slot provided',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            productHandle: 'premium-christmas-delivery',
            seasonalDelivery: true,
            includedDays: [
              '2022-12-19', '2022-12-20',
              '2022-12-21', '2022-12-22'
            ]
          },
          {
            title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            seasonalDelivery: true,
            includedDays: [],
            productHandle: 'panther-weekday'
          }
        ]
      },
      {
        name: 'PH12',
        leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
        excludedDays: [],
        excludedDates: [
          [
            '2022-12-23',
            '2022-12-24',
            '2022-12-25',
            '2022-12-26',
            '2022-12-27',
            '2022-12-31',
            '2023-01-01'
          ]
        ],
        services: [
          {
            title: 'Free Delivery',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
            productHandle: 'standard-weekday'
          },
          {
            title: 'Bike Delivery',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            productHandle: 'panther-weekday'
          },
          {
            title: 'Christmas premium - 2 hour time slot provided',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            productHandle: 'premium-christmas-delivery',
            seasonalDelivery: true,
            includedDays: [
              '2022-12-19', '2022-12-20',
              '2022-12-21', '2022-12-22'
            ]
          },
          {
            title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            seasonalDelivery: true,
            includedDays: [],
            productHandle: 'panther-weekday'
          }
        ]
      },
      {
        name: 'PH13',
        leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
        excludedDays: [],
        excludedDates: [
          [
            '2022-12-23',
            '2022-12-24',
            '2022-12-25',
            '2022-12-26',
            '2022-12-27',
            '2022-12-31',
            '2023-01-01'
          ]
        ],
        services: [
          {
            title: 'Free Delivery',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
            productHandle: 'standard-weekday'
          },
          {
            title: 'Bike Delivery',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            productHandle: 'panther-weekday'
          },
          {
            title: 'Christmas premium - 2 hour time slot provided',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            productHandle: 'premium-christmas-delivery',
            seasonalDelivery: true,
            includedDays: [
              '2022-12-19', '2022-12-20',
              '2022-12-21', '2022-12-22'
            ]
          },
          {
            title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            seasonalDelivery: true,
            includedDays: [],
            productHandle: 'panther-weekday'
          }
        ]
      },
      {
        name: 'PH14',
        leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
        excludedDays: [],
        excludedDates: [
          [
            '2022-12-23',
            '2022-12-24',
            '2022-12-25',
            '2022-12-26',
            '2022-12-27',
            '2022-12-31',
            '2023-01-01'
          ]
        ],
        services: [
          {
            title: 'Free Delivery',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
            productHandle: 'standard-weekday'
          },
          {
            title: 'Bike Delivery',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            productHandle: 'panther-weekday'
          },
          {
            title: 'Christmas premium - 2 hour time slot provided',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            productHandle: 'premium-christmas-delivery',
            seasonalDelivery: true,
            includedDays: [
              '2022-12-19', '2022-12-20',
              '2022-12-21', '2022-12-22'
            ]
          },
          {
            title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            seasonalDelivery: true,
            includedDays: [],
            productHandle: 'panther-weekday'
          }
        ]
      },
      {
        name: 'PH15',
        leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
        excludedDays: [],
        excludedDates: [
          [
            '2022-12-23',
            '2022-12-24',
            '2022-12-25',
            '2022-12-26',
            '2022-12-27',
            '2022-12-31',
            '2023-01-01'
          ]
        ],
        services: [
          {
            title: 'Free Delivery',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
            productHandle: 'standard-weekday'
          },
          {
            title: 'Bike Delivery',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            productHandle: 'panther-weekday'
          },
          {
            title: 'Christmas premium - 2 hour time slot provided',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            productHandle: 'premium-christmas-delivery',
            seasonalDelivery: true,
            includedDays: [
              '2022-12-19', '2022-12-20',
              '2022-12-21', '2022-12-22'
            ]
          },
          {
            title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            seasonalDelivery: true,
            includedDays: [],
            productHandle: 'panther-weekday'
          }
        ]
      },
      {
        name: 'PH16',
        leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
        excludedDays: [],
        excludedDates: [
          [
            '2022-12-23',
            '2022-12-24',
            '2022-12-25',
            '2022-12-26',
            '2022-12-27',
            '2022-12-31',
            '2023-01-01'
          ]
        ],
        services: [
          {
            title: 'Free Delivery',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
            productHandle: 'standard-weekday'
          },
          {
            title: 'Bike Delivery',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            productHandle: 'panther-weekday'
          },
          {
            title: 'Christmas premium - 2 hour time slot provided',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            productHandle: 'premium-christmas-delivery',
            seasonalDelivery: true,
            includedDays: [
              '2022-12-19', '2022-12-20',
              '2022-12-21', '2022-12-22'
            ]
          },
          {
            title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            seasonalDelivery: true,
            includedDays: [],
            productHandle: 'panther-weekday'
          }
        ]
      },
      {
        name: 'PH17',
        leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
        excludedDays: [],
        excludedDates: [
          [
            '2022-12-23',
            '2022-12-24',
            '2022-12-25',
            '2022-12-26',
            '2022-12-27',
            '2022-12-31',
            '2023-01-01'
          ]
        ],
        services: [
          {
            title: 'Free Delivery',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
            productHandle: 'standard-weekday'
          },
          {
            title: 'Bike Delivery',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            productHandle: 'panther-weekday'
          },
          {
            title: 'Christmas premium - 2 hour time slot provided',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            productHandle: 'premium-christmas-delivery',
            seasonalDelivery: true,
            includedDays: [
              '2022-12-19', '2022-12-20',
              '2022-12-21', '2022-12-22'
            ]
          },
          {
            title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            seasonalDelivery: true,
            includedDays: [],
            productHandle: 'panther-weekday'
          }
        ]
      },
      {
        name: 'PH18',
        leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
        excludedDays: [],
        excludedDates: [
          [
            '2022-12-23',
            '2022-12-24',
            '2022-12-25',
            '2022-12-26',
            '2022-12-27',
            '2022-12-31',
            '2023-01-01'
          ]
        ],
        services: [
          {
            title: 'Free Delivery',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
            productHandle: 'standard-weekday'
          },
          {
            title: 'Bike Delivery',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            productHandle: 'panther-weekday'
          },
          {
            title: 'Christmas premium - 2 hour time slot provided',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            productHandle: 'premium-christmas-delivery',
            seasonalDelivery: true,
            includedDays: [
              '2022-12-19', '2022-12-20',
              '2022-12-21', '2022-12-22'
            ]
          },
          {
            title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
            days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
            minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
            seasonalDelivery: true,
            includedDays: [],
            productHandle: 'panther-weekday'
          }
        ]
    },
    {
      name: 'PH19',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH20',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH21',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH22',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH23',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH24',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH25',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH26',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH30',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH31',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH32',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH33',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH34',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH35',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH36',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH37',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH38',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH39',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH4',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH40',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH41',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH42',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: {
            mon: 13,
            tue: 13,
            wed: 13,
            thu: 13,
            fri: 11,
            sat: 11,
            sun: 12
          },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH43',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: {
            mon: 13,
            tue: 13,
            wed: 13,
            thu: 13,
            fri: 11,
            sat: 11,
            sun: 12
          },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH44',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: {
            mon: 13,
            tue: 13,
            wed: 13,
            thu: 13,
            fri: 11,
            sat: 11,
            sun: 12
          },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH45',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH46',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH47',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH48',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH49',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH5',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH50',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH6',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH7',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH8',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PH9',
      leadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 7, sat: 6, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 7, tue: 7, wed: 7, thu: 7, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PL10',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PL11',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PL13',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PL23',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PL28',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PL29',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PL8',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PL9',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PO30',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PO31',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PO32',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PO33',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PO34',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PO35',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PO36',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PO37',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PO38',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PO39',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PO40',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'PO41',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: ['tue', 'thu'],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA1',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA10',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA11',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA12',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA13',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA14',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA15',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA16',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA17',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA18',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA19',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA2',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA20',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA21',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA22',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA23',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA24',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA25',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA26',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA27',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA28',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA29',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA3',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA30',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA31',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA32',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA33',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA34',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA35',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA36',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA37',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA38',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA39',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA4',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA41',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA42',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA43',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA44',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA45',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA46',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA47',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA48',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA49',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA5',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA50',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA51',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA52',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA53',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA54',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA55',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA56',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA57',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA58',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA59',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA6',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA60',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA61',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA62',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA63',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA64',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA65',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA66',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA67',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA68',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA69',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA7',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA70',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA71',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA72',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA73',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA8',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA80',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SA9',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SS3',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SS4',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SY1',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SY10',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SY11',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SY12',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SY13',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SY14',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SY15',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SY16',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SY17',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SY18',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SY19',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SY2',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SY20',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SY21',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SY22',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SY23',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SY24',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SY25',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SY3',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SY4',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SY5',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SY6',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SY7',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SY8',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'SY9',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TD',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TD1',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TD10',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TD11',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TD12',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TD13',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TD14',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TD15',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TD2',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TD3',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TD4',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TD5',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TD6',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TD7',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TD8',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TD9',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TQ5',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TQ6',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TQ7',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TQ8',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TR1',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TR10',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TR11',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TR12',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TR13',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TR14',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TR15',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TR16',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TR17',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TR18',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TR19',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TR2',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TR20',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TR26',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TR27',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TR3',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TR4',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TR5',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TR6',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TR7',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TR8',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'TR9',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'WC',
      leadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 5 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    },
    {
      name: 'default',
      leadTimes: { mon: 5, tue: 7, wed: 7, thu: 7, fri: 7, sat: 7, sun: 6 },
      excludedDays: [],
      excludedDates: [
          '2022-12-23',
          '2022-12-24',
          '2022-12-25',
          '2022-12-26',
          '2022-12-27',
          '2022-12-31',
          '2023-01-01'
      ],
      services: [
        {
          title: 'Free Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 11, tue: 11, wed: 9, thu: 9, fri: 9, sat: 9, sun: 10 },
          productHandle: 'standard-weekday'
        },
        {
          title: 'Bike Delivery',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 7, wed: 7, thu: 7, fri: 7, sat: 7, sun: 6 },
          productHandle: 'panther-weekday'
        },
        {
          title: 'Saturday premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday'
        },
        {
          title: 'Sunday premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday'
        },
        {
          title: 'Christmas premium - 2 hour time slot provided',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 4, wed: 5, thu: 4, fri: 5, sat: 7, sun: 7 },
          productHandle: 'premium-christmas-delivery',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Saturday Christmas premium - 2 hour time slot provided',
          days: [ 'sat' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 5, sun: 6 },
          productHandle: 'panther-saturday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Sunday Christmas premium - 2 hour time slot provided',
          days: [ 'sun' ],
          minimumLeadTimes: {
            mon: 10,
            tue: 10,
            wed: 10,
            thu: 9,
            fri: 9,
            sat: 11,
            sun: 5
          },
          productHandle: 'panther-sunday-christmas',
          seasonalDelivery: true,
          includedDays: [
            '2022-12-19', '2022-12-20',
            '2022-12-21', '2022-12-22'
          ]
        },
        {
          title: 'Premium Express - 2 hour time slot provided (Bank Holiday)',
          days: [ 'mon', 'tue', 'wed', 'thu', 'fri' ],
          minimumLeadTimes: { mon: 5, tue: 5, wed: 5, thu: 5, fri: 5, sat: 7, sun: 7 },
          seasonalDelivery: true,
          includedDays: [],
          productHandle: 'panther-weekday'
        }
      ]
    }
  ]
}